// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import './plugins/DetectBrowser';

Vue.config.productionTip = false;

import Vue2TouchEvents from 'vue2-touch-events';
Vue.use(Vue2TouchEvents, {
  disableClick: true
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js